/**
 * 6529.io API
 * This is the API interface description. Brief terminology overview and an authentication example can be found at <a href=\"https://6529.io/about/api\">https://6529.io/about/api</a>.
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { HttpFile } from '../http/http';

export class ApiWaveDecisionsStrategy {
    /**
    * When the first decision will be made. All subsequent decision times will be calculated based on this.
    */
    'first_decision_time': number;
    /**
    * Each element in this array represents the milliseconds passed from previous decision when new decision is made. When is_rolling=true then after last decision, the next decision will be made again first-element-of-the-array milliseconds later than the previous one. And it will continue like this forever.
    */
    'subsequent_decisions': Array<number>;
    /**
    * If false then there will be length(subsequent_decisions) + 1 decisions in total. If true then there will be infinite number of decisions (see description of subsequent_decisions). Also if true then there needs to be at least one element in subsequent_decisions array.
    */
    'is_rolling': boolean;

    static readonly discriminator: string | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "first_decision_time",
            "baseName": "first_decision_time",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "subsequent_decisions",
            "baseName": "subsequent_decisions",
            "type": "Array<number>",
            "format": "int64"
        },
        {
            "name": "is_rolling",
            "baseName": "is_rolling",
            "type": "boolean",
            "format": ""
        }    ];

    static getAttributeTypeMap() {
        return ApiWaveDecisionsStrategy.attributeTypeMap;
    }

    public constructor() {
    }
}

